import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ClassifiedTopVideosComponent } from '../classified-top-videos.component';

@Component({
  selector: 'div.new-list',
  templateUrl: './classified-top-videos-news.component.html',
  styleUrls: ['../classified-top-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ClassifiedTopVideosNewsComponent extends ClassifiedTopVideosComponent implements OnInit {
  showOutDated = false;
  playingMediaKey = '';
  ngOnInit(): void {
    super.ngOnInit();
    if (this.isNewsList.indexOf(this.slug) > -1) {
      this.display = 7;
      // this.autoHeight = true;
    }
  }
  isNewsList = ['news', 'yule', 'life', 'music', 'fashion', 'tech', 'chinese', 'games','game']


  currentMediaKeyHandler(e) {
    this.playingMediaKey = e;
  }

  previewHandler(playerShowed) {
    if (playerShowed === true) {
      let firstItem;
      let lastItem;
      if (this.currentIndex < this.newColumn) {
        const lastItemIndex = this.currentIndex + (this.newColumn - 1);
        lastItem = this.recommendedVideos[lastItemIndex];
      } else {
        const firstItemIndex = this.currentIndex;
        firstItem = this.recommendedVideos[firstItemIndex];
        const lastItemIndex = this.currentIndex + (this.newColumn - 1);
        lastItem = this.recommendedVideos[lastItemIndex];
      }
      this.zIndexChange(firstItem, lastItem);
    } else {
      this.hideLeft = false;
      this.hideRight = false;
    }
  }

  hideLeft = false;
  hideRight = false;

  zIndexChange(firstItem = undefined, lastItem = undefined) {
    if (!!firstItem && firstItem.key === this.playingMediaKey) {
      this.hideLeft = true;
    }
    if (!!lastItem && lastItem.key === this.playingMediaKey) {
      this.hideRight = true;
    }
  }

}
